var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "r0hyl66r5a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.537255 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "3g92huqn5b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#r0hyl66r5a)",
    transform: "translate(-586 -726)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#3g92huqn5b)",
    transform: "translate(586 726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.256 0.256L20.744 0.256 20.744 20.744 0.256 20.744z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M3.088 11.324h6.588V3.088H3.088v8.236zm0 6.588h6.588V12.97H3.088v4.94zm8.236 0h6.588V9.676h-6.588v8.236zm0-14.824V8.03h6.588V3.09h-6.588z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanedIcon);
export default __webpack_public_path__ + "static/media/cleaned-icon.2e43947b950abdacf1fc5f08f8173433.svg";
export { ForwardRef as ReactComponent };